import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import { getOptimizelyFeatureFlagVariation } from 'lib/optimizely/optimizelyUtils'
import { createSelector } from 'reselect'
import { isSpoofed } from 'selectors/featuresSelectors'
import { isPassportCardStartDateWithinAllowedRange } from 'checkout/Components/CheckoutSteps/Review/PassportCardInsurance/passportCardUtils'
import getInsuranceDatesFromCart from './getInsuranceDatesFromCart'
import { hasPassportCardEligibleItems } from '../view/itemViews/getPassportCardQuoteItems'

const isPassportCardExclusiveCheckoutEnabled = createSelector(
  (state: App.State) => getOptimizelyFeatureFlagVariation(state, OptimizelyFeatureFlags.croPassportCardExclusiveCheckout),
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => isSpoofed(state),
  (state: App.State) => getInsuranceDatesFromCart(state)?.startDate,
  (state: App.State) => hasPassportCardEligibleItems(state),
  (
    isPassportCardExclusiveCheckoutFlagEnabled,
    regionCode,
    spoofed,
    checkoutStartDate,
    cartHasEligibleItems,
  ): boolean => {
    if (!isPassportCardExclusiveCheckoutFlagEnabled) return false
    if (regionCode !== 'AU') return false
    if (spoofed) return false
    if (!isPassportCardStartDateWithinAllowedRange(checkoutStartDate)) return false
    return cartHasEligibleItems
  },
)

export default isPassportCardExclusiveCheckoutEnabled
